import React from 'react'
import Slider from "react-slick";
import './carousel.css'

const settings = {
    infinite: true,
    arrows: true,
    speed: 1,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseonhover: false,
    cssEase: "linear"
};

function Carousel({ type }) {
    // const carouselBackgrounds = [
    //     'orange',
    //     'purple',
    //     'blue'
    // ]

    // 'https://res.cloudinary.com/emacon-production/image/upload/v1648985732/the-outlet/Artboard_1Final_1_rktvdm.png',
    //     'https://res.cloudinary.com/emacon-production/image/upload/v1648985736/the-outlet/Artboard_1_copyFinal_1_ufhtsq.png',
    
    const carouselImages = [
        'carousel__background1',
        'carousel__background2',
        'carousel__background3',
        'carousel__background4',
        'carousel__background5'
    ]

    // const productCarousel = [
    //     {
    //         name: "Gilbeys",
    //         quantity: '750ml',
    //         price: '5,000',
    //         image: 'https://res.cloudinary.com/emacon-production/image/upload/v1639035483/the-outlet/42-liqueur-bottle-png-image_mum5x1.png'
    //     },
    //     {
    //         name: "Gilbeys",
    //         quantity: '750ml',
    //         price: '5,000',
    //         image: 'https://res.cloudinary.com/emacon-production/image/upload/v1639037945/the-outlet/33-vodka-bottle-png-image_dwzkyc.png'
    //     },
    //     {
    //         name: "Gilbeys",
    //         quantity: '750ml',
    //         price: '5,000',
    //         image: 'https://res.cloudinary.com/emacon-production/image/upload/v1639035483/the-outlet/3-champaign-bottle-png-image_ztwnva.png'
    //     }
    // ]
    return (
            <Slider {...settings} className="carousel" >
                {
                    carouselImages.map((item, index) => (
                        <div className={`${item} ${type}`} key={index}>
                            {/* <img src={item} alt="" /> */}
                            <div className='black_wrapper' onClick={() => window.location.href = "https://theoutletvendor.netlify.app/"} ></div>
                        </div>
                    ))
                }
            </Slider>
    )
}

export default Carousel
